import React, { useContext } from "react";
import {AuthContext} from "../Components/Context";

export const HasPermission = ( permission ) => {
    const {currentUser}=useContext(AuthContext);
    console.log(permission)
      const userHasPermission = currentUser && currentUser.permission?.includes(permission) ? true : false;
      return userHasPermission;
  
    }